import './View.css'
import './ReferenceLines/ReferenceLines.css'
import { VoltageDiagram, LevelDiagram, Headers } from './Draw'
import { useRef, useState } from 'react'
import { LTS, STS, VSUP, BatLow, HrvLow, VAUX } from './Functions'
import ReferenceLines from './ReferenceLines'
import ReferenceNames from './ReferenceNames'
import { toCanvas } from 'html-to-image';
import { useSettings } from 'Settings'
import { ExportAsSegment, ExportThreeSegments } from './Image'
import { Modal } from 'react-bootstrap'
import { GroupSelect } from 'GroupSelect'

const voltage_diagram_rect = {
	x : 50,
	y : 450,
	width : 1350,
	height : 430,
	graph : {
		width: 9,
		height: 5
	}
}

const low_bat_rect = {
	x : 50,
	y : 500,
	width : 1350,
	height: 25,
	graph : {
		width: 9,
		height: 1
	}
}

const low_hrv_rect = {
	x : 50,
	y : 560,
	width : 1350,
	height: 25,
	graph : {
		width: 9,
		height: 1
	}
}

const exports = [
	{value : 'whole', label : 'Whole'},
	{value : 'threesegments', label : 'Three Segments'},
	{value : 'start-up', label : 'Start-Up'},
	{value : 'maintain-sts', label : 'Maintain-STS / Application'},
	{value : 'operating1', label : 'Operating 1'},
	{value : 'noinput1', label : 'No Input 1'},
	{value : 'applrestart', label : 'Appl Restart'},
	{value : 'operating2', label : 'Operating 2'},
	{value : 'vsupsleep', label : 'VSUP Sleep'},
	{value : 'noinput 2', label : 'No Input 2'},
	{value : 'shut-down', label : 'Shut-Down'},
]

const segments = [
	'start-up',
	'maintain-sts',
	'operating1',
	'noinput1',
	'applrestart',
	'operating2',
	'vsupsleep',
	'noinput 2',
	'shut-down'
]

const ToggleButton = ({ toggle, onToggle, className, name }) => {
	return (
		<button
			className={`btn d-flex border-2 border-bottom rounded-0 ${className} ${!toggle ? 'border-opacity-25' : ''}`}
			onClick={onToggle}
			>
			<i className={`bi bi-eye${!toggle ? '-slash' : ''} pe-1`}></i> {name}
		</button>
	)
}

export default function TimingDiagramView() {
	const [settings] = useSettings()
	const hrv_element = settings['harvester power supervisory']['harvesting element'].value

	const diagram_scroll = useRef()
	const diagram_view = useRef()

	const [show, setShow] = useState()
	const [exportType, setExportType] = useState()

	const [showSTS, setShowSTS] = useState(true)
	const [showLTS, setShowLTS] = useState(true)
	const [showVSUP, setShowVSUP] = useState(true)
	const [showVAUX0, setShowVAUX0] = useState(true)
	const [showVAUX1, setShowVAUX1] = useState(true)
	const [showVAUX2, setShowVAUX2] = useState(true)

	const handleShow = () => setShow(true)
	const handleHide = () => setShow(false)

	const toggleSTS = () => setShowSTS(!showSTS)
	const toggleLTS = () => setShowLTS(!showLTS)
	const toggleVSUP = () => setShowVSUP(!showVSUP)
	const toggleVAUX0 = () => setShowVAUX0(!showVAUX0)
	const toggleVAUX1 = () => setShowVAUX1(!showVAUX1)
	const toggleVAUX2 = () => setShowVAUX2(!showVAUX2)

	const handleSave = () => {
		if (exportType !== 'whole' && exportType !== 'threesegments') {
			const referenceNames = document.querySelectorAll('.reference-name');
			referenceNames.forEach((rn) => {
				rn.style.display = 'none'
			})
		}

		toCanvas(diagram_view.current, { width: 1450, height: 600, pixelRatio: 2, backgroundColor : 'white' })
			.then((canvas) => {
				let imgs = []

				if (exportType === 'whole') {
					imgs.push({
						name : 'diagram',
						data : canvas.toDataURL('image/png')
					})
				} else if (exportType === 'threesegments') {
					imgs = ExportThreeSegments(canvas)
				} else {
					const index = segments.findIndex((s) => s === exportType)
					imgs.push({
						name : 'diagram-' + exportType,
						data : ExportAsSegment(canvas, 90 + index * 300, 320)
					})

					const referenceNames = document.querySelectorAll('.reference-name');
					referenceNames.forEach((rn) => {
						rn.style.display = ''
					})
				}

				imgs.forEach((img) => {
					const link = document.createElement('a')
					link.download = img.name + '.png'
					link.href = img.data
					link.click()
				})

			})
			.catch((err) => {
				console.log(err)
			})

	}

	return (
		<div
			ref={diagram_scroll}
			className="diagram-scroll mb-3 align-self-start flex-grow-1"
			>

			<div className="control-panel d-flex">
				<button className="btn" onClick={handleShow} >
					<i className="bi bi-box-arrow-right"></i>
				</button>
				<ToggleButton
					name="LTS"
					toggle={showLTS}
					onToggle={toggleLTS}
					className="border-danger"
				/>
				<ToggleButton
					name="STS"
					toggle={showSTS}
					onToggle={toggleSTS}
					className="border-primary"
				/>
				<ToggleButton
					name="VSUP"
					toggle={showVSUP}
					onToggle={toggleVSUP}
					className="border-success"
				/>
				<ToggleButton
					name="VAUX[0]"
					toggle={showVAUX0}
					onToggle={toggleVAUX0}
					className="border-secondary"
				/>
				<ToggleButton
					name="VAUX[1]"
					toggle={showVAUX1}
					onToggle={toggleVAUX1}
					className="border-secondary"
				/>
				<ToggleButton
					name="VAUX[2]"
					toggle={showVAUX2}
					onToggle={toggleVAUX2}
					className="border-secondary"
				/>
			</div>

			<div ref={diagram_view}>
				<svg className="diagram" viewBox="0 0 1450 600" stroke="black" strokeWidth="1">
					<VoltageDiagram rect={ voltage_diagram_rect } />
					<LevelDiagram rect={ low_bat_rect } name='bat_low'/>
					{
					hrv_element === 'teg' ? <></> :
						<LevelDiagram rect={ low_hrv_rect } name='hrv_low'/>
					}
					<Headers />
					<STS
						rect={voltage_diagram_rect}
						className={`graph-blue ${showSTS ? '' : 'hidden'}`}
						strokeWidth="3"
					/>
					<LTS
						rect={voltage_diagram_rect}
						className={`graph-red ${showLTS ? '' : 'hidden'}`}
						strokeWidth="3"
						strokeDasharray="5 5"
					/>
					<VAUX
						vaux="0"
						rect={voltage_diagram_rect}
						className={`graph-gray-300 ${showVAUX0 ? '' : 'hidden'}`}
						strokeWidth="3"
						strokeDasharray="10 5"
					/>
					<VAUX
						vaux="1"
						rect={voltage_diagram_rect}
						className={`graph-gray-500 ${showVAUX1 ? '' : 'hidden'}`}
						strokeWidth="3"
						strokeDasharray="15 5"
					/>
					<VAUX
						vaux="2"
						rect={voltage_diagram_rect}
						className={`graph-gray-800 ${showVAUX2 ? '' : 'hidden'}`}
						strokeWidth="3"
						strokeDasharray="5 15"
					/>
					<VSUP
						rect={voltage_diagram_rect}
						className={`graph-green ${showVSUP ? '' : 'hidden'}`}
						strokeWidth="3"
						strokeDasharray="10 10"
					/>
					<ReferenceLines rect={voltage_diagram_rect} />
					<BatLow
						rect={low_bat_rect}
						className="graph-red"
						strokeWidth="3"
					/>
					{
					hrv_element === 'teg' ? <></> :
					<HrvLow
						rect={low_hrv_rect}
						className="graph-red"
						strokeWidth="3"
					/>
				}
				</svg>
				<ReferenceNames rect={voltage_diagram_rect} />
			</div>
			<Modal show={show} onHide={handleHide}>
				<Modal.Header>
					<Modal.Title>Export Diagram</Modal.Title>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={handleHide}></button>
				</Modal.Header>
				<Modal.Body>
					<GroupSelect
						options={exports}
						value={exportType}
						name="Type"
						onChange={(v) => setExportType(v.value)}
					/>
				</Modal.Body>
				<Modal.Footer>
					<button
						className="btn"
						onClick={handleSave}
						>
						Export
					</button>
				</Modal.Footer>
			</Modal>
		</div>
	)
}

